import React, {useState} from 'react';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import MapContent from './MapContent';
import { useSelector } from 'react-redux';


const Map = (props) => {
    const defaultPoint = {lat:52.520008, lon:13.404954};
    const defaultZoom = 8;
    const {miniMapHeight, miniMapWidth} = useSelector((store)=>store.map);
    return(
        <>
            <MapContainer 
                style={{ minHeight: miniMapHeight, width: miniMapWidth}} 
                center={defaultPoint} 
                zoom={defaultZoom}
                maxZoom={16} 
                dragging={true} 
                attributionControl={true}>
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
                    attribution="&copy; OSM | Tiles &copy; Esri"
                    //url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
                    //attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>'

                />
                <MapContent color={props.color} point={defaultPoint} zoom={defaultZoom} />
            </MapContainer>   
        </>
    )
}


export default Map;